import className from 'classnames/bind';
import { SplideSlide } from 'react-splide-ts';
import { QuoteCarouselFragment } from "@graphqlTypes";
import { Image } from '@components';

import styles from './QuoteCarousel.module.scss';
const cx = className.bind(styles);

type SlideProps = {
  slide: QuoteCarouselFragment['items'][number];
};

export default function Slide({ slide }: SlideProps) {
  const { image, quote, attribution: { name, title } } = slide;
  const showAttribution = Boolean(name || title);
  return (
    <SplideSlide className={cx('slide')} aria-label={name}>
      <div className={cx('image')}>
        <Image image={image} />
      </div>
      <div className={cx('content')}>
        { quote && <p className={cx('quote', 'title-lc-xs')}>“{quote}”</p> }
        {showAttribution && (
          <div className={cx('attribution')}>
            { name && <p className={cx('name', 'eyebrow-l')}>{name}</p> }
            { title && <p className={cx('title', 'tag-s')}>{title}</p> }
          </div>
        )}
      </div>
    </SplideSlide>
  );
};